const PENDING_PROJECT_KEY = 'landscope_pending_project';
const EMAIL_VERIFICATION_KEY = 'landscope_email_verification_pending';
const EMAIL_VERIFICATION_EMAIL_KEY = 'landscope_email_verification_email';
export const pendingProjectUtils = {
    /**
     * Store a pending project in localStorage
     */
    store: (projectData) => {
        const pendingProject = {
            ...projectData,
            timestamp: Date.now()
        };
        try {
            localStorage.setItem(PENDING_PROJECT_KEY, JSON.stringify(pendingProject));
        }
        catch (error) {
            console.error('Failed to store pending project to localStorage:', error);
        }
    },
    /**
     * Retrieve pending project from localStorage
     */
    retrieve: () => {
        try {
            const stored = localStorage.getItem(PENDING_PROJECT_KEY);
            if (!stored)
                return null;
            const pendingProject = JSON.parse(stored);
            // Check if the pending project is older than 24 hours
            const twentyFourHours = 24 * 60 * 60 * 1000;
            if (Date.now() - pendingProject.timestamp > twentyFourHours) {
                pendingProjectUtils.clear();
                return null;
            }
            return pendingProject;
        }
        catch (error) {
            console.error('Failed to retrieve pending project from localStorage:', error);
            return null;
        }
    },
    /**
     * Clear pending project from localStorage
     */
    clear: () => {
        try {
            localStorage.removeItem(PENDING_PROJECT_KEY);
        }
        catch (error) {
            console.error('Failed to clear pending project from localStorage:', error);
        }
    },
    /**
     * Check if there's a pending project
     */
    hasPending: () => {
        return pendingProjectUtils.retrieve() !== null;
    }
};
/**
 * Email verification utilities
 */
export const emailVerificationUtils = {
    /**
     * Set email verification as pending (invitation sent). The email is stored
     * alongside the timestamp so the in-app "check your inbox" state can offer a
     * one-click resend without making the user re-type their address.
     */
    setPending: (email) => {
        try {
            const timestamp = Date.now();
            localStorage.setItem(EMAIL_VERIFICATION_KEY, timestamp.toString());
            if (email) {
                localStorage.setItem(EMAIL_VERIFICATION_EMAIL_KEY, email);
            }
        }
        catch (error) {
            console.error('Failed to set email verification pending status:', error);
        }
    },
    /**
     * Get the email address the pending verification was sent to, if stored.
     */
    getEmail: () => {
        try {
            return localStorage.getItem(EMAIL_VERIFICATION_EMAIL_KEY);
        }
        catch (error) {
            console.error('Failed to get pending verification email:', error);
            return null;
        }
    },
    /**
     * Check if email verification is pending
     */
    isPending: () => {
        try {
            const stored = localStorage.getItem(EMAIL_VERIFICATION_KEY);
            if (!stored)
                return false;
            // Check if email verification pending is older than 24 hours
            const twentyFourHours = 24 * 60 * 60 * 1000;
            const timestamp = parseInt(stored, 10);
            if (Date.now() - timestamp > twentyFourHours) {
                emailVerificationUtils.clear();
                return false;
            }
            return true;
        }
        catch (error) {
            console.error('Failed to check email verification pending status:', error);
            return false;
        }
    },
    /**
     * Clear email verification pending status
     */
    clear: () => {
        try {
            localStorage.removeItem(EMAIL_VERIFICATION_KEY);
            localStorage.removeItem(EMAIL_VERIFICATION_EMAIL_KEY);
        }
        catch (error) {
            console.error('Failed to clear email verification pending status:', error);
        }
    },
    /**
     * Get timestamp when email verification was set as pending
     */
    getTimestamp: () => {
        try {
            const stored = localStorage.getItem(EMAIL_VERIFICATION_KEY);
            return stored ? parseInt(stored, 10) : null;
        }
        catch (error) {
            console.error('Failed to get email verification timestamp:', error);
            return null;
        }
    }
};
